import { Component, Input, Output, EventEmitter, ChangeDetectorRef, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiService } from '../../../apiConnection/ApiService';
import { CustomModalComponent } from '../../../components/custom-modal/custom-modal.component';
import { Urls } from '../../../apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { Utils } from '@/utils/utils';
import { LoadingComponent } from '@/components/loading/loading.component';

@Component({
  selector: 'app-category-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './category-form.component.html',
  styleUrl: './category-form.component.scss',
})
export class CategoryFormComponent {
  @Input() id = 0;
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);

  public saveForm: FormGroup = new FormGroup({});

  public showModalImage = false

  public dropdowns: any = {}

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();

    if (this.id != 0) {
      this.getById(this.id);
    }
  }

  acceptFormFunction() {
    this.saveEntity()
  }

  closeFormFunction() {
    this.closeFunction.emit();
  }

  createForm() {
    this.saveForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      code: new FormControl('', [Validators.required]),
      order: new FormControl(null), // Opcional

    })
  }


  getById(id: number) {
    this.loading.set(true);
    this.apiService.getById(Urls.urls.categories, id).subscribe({
      next: (data: any) => {
        this.saveForm.patchValue(data);
        this.loading.set(false);

        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.error('ERROR obtener productos. ' + error);
      },
      complete: () => {
        this.loading.set(false);
      },
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);

      this.apiService.save(Urls.urls.categories, this.saveForm.value, this.id).subscribe({
        next: (response: any) => {
          Utils.notification.success("Familia guardada")
          this.acceptFunction.emit(response);
          this.closeFormFunction()
        },
        error: (error: any) => {
          const codeControl = this.saveForm.get('code');
          const codeTaken = Utils.isCodeAlreadyTakenError(error);

          this.saving.set(false);
          this.cdr.detectChanges();

          if (codeTaken) {
            codeControl?.setErrors({ codeTaken: true });
            codeControl?.markAsTouched();
            Utils.notification.alert(`El código "${codeControl?.value}" ya existe en otra familia`);
            return;
          }

          Utils.notification.alert(Utils.extractErrorMessage(error) || "Error al guardar la familia")
        },
        complete: () => {
          this.saving.set(false);
        }
      })
    } else {
      Utils.notification.alert("Debe completar todos los campos obligatorios")
    }
  }

}
